import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, key } = useLocation();

  // Use useLayoutEffect to scroll before the browser paints
  // This handles both forward navigation and back/forward button
  useLayoutEffect(() => {
    // Instant jump to top - no animation
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, key]); // key changes on every navigation including back/forward

  // Also override the browser's scroll restoration
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return null;
};

export default ScrollToTop;
